import roles from '@/utils/constants/roles.js';

const normalizeRole = (role) => String(role || '').trim().toLowerCase();

const roleEquals = (role, expectedRole) =>
  normalizeRole(role) === normalizeRole(expectedRole);

export const isApplicantRole = (role) => roleEquals(role, roles.APPLICANT);

export const isSupervisorRole = (role) => roleEquals(role, roles.SUPERVISOR);

export const isAdminRole = (role) => roleEquals(role, roles.ADMIN);

export const isInvestigatorRole = (role) =>
  roleEquals(role, roles.INVESTIGATOR);

export const canCreateRequest = (role) => isApplicantRole(role);

export const canUseOwnRequestScopeOnly = (role) => isApplicantRole(role);

export const canChangeStatus = (role) =>
  isSupervisorRole(role) || isAdminRole(role) || isInvestigatorRole(role);

export const canManageAssignments = (role) =>
  isSupervisorRole(role) || isAdminRole(role);

export const canManageStamping = (role) =>
  isSupervisorRole(role) || isAdminRole(role);

export const canAccessReports = (role) => isAdminRole(role);

export const canManageUsers = (role) => isAdminRole(role);

export default {
  isApplicantRole,
  isSupervisorRole,
  isAdminRole,
  isInvestigatorRole,
  canCreateRequest,
  canUseOwnRequestScopeOnly,
  canChangeStatus,
  canManageAssignments,
  canManageStamping,
  canAccessReports,
  canManageUsers,
};
